export default __webpack_public_path__ + "static/media/comic14_2.f6757a0f.png";